import {
  GET_MEMBER_SUCCESS
} from '../mutation-types'

// initial state
const state = {
  users: {},
  status: {
    getUser: {}
  }
}

// getters
const getters = {
  user: function (state) {
    return function (userId) {
      return state.users[userId]
    }
  }
}

// mutations
const mutations = {
  [GET_MEMBER_SUCCESS]: function (state, data) {
    state.users = {...state.users, [data.userId]: data}
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/users.js